import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Modal, Button, Spinner, Row, Col, Container } from 'react-bootstrap';
import { STATE_STATUS } from '@awp/constants';

import {
  setGraphViewId,
  getGraphViewName,
  deleteGraphView,
  selectViewDeleteState,
  currentGraphViewId,
} from '@stores/graphViewPageSlice';

import PropTypes from 'prop-types';

const DeleteModal = ({ isOpen, toggleModal }) => {
  const dispatch = useDispatch();
  const deleteState = useSelector(selectViewDeleteState);
  const graphViewName = useSelector(getGraphViewName);

  const graphViewId = useSelector(currentGraphViewId);

  const closeModal = () => {
    //reset the warnings
    if (isOpen) toggleModal();
  };

  const cancelDelete = () => {
    if (isOpen) toggleModal();
  };

  useEffect(() => {
    if (deleteState == STATE_STATUS.SUCCESS) {
      closeModal();
    }
  }, [deleteState]);

  const deleteView = () => {
    dispatch(deleteGraphView(graphViewId));
    dispatch(setGraphViewId(null));
  };

  return (
    <Modal
      show={isOpen}
      onHide={toggleModal}
      backdrop="static"
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title style={{ width: '100%' }}>
          <Container fluid>
            <Row>
              <Col md={{ span: 6, offset: 3 }} className="d-flex justify-content-center">
                <i className="bi-trash-fill display-3 text-danger disabled"></i>
              </Col>
            </Row>
            <Row>
              <Col md={{ span: 6, offset: 3 }}>
                <div className="d-flex justify-content-center text-danger font-weight-bold mt-1">Delete Graph View</div>
              </Col>
            </Row>
          </Container>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-center">
          <p>
            {'Do you want to delete '}
            <b>{graphViewName}</b>
          </p>
        </div>
        <div className="d-flex justify-content-center">This action cannot be undone</div>
      </Modal.Body>
      {deleteState != STATE_STATUS.LOADING ? (
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelDelete}>
            No, Keep View
          </Button>
          <Button variant="danger" onClick={deleteView}>
            Yes, Delete View
          </Button>
        </Modal.Footer>
      ) : (
        <Modal.Footer>
          <Button variant="primary" disabled>
            <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
            Deleting...
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

DeleteModal.propTypes = {
  isOpen: PropTypes.bool,
  toggleModal: PropTypes.func,
};

export default DeleteModal;
